import { cn } from "@/lib/utils";

export const FRAME_PADDING = 4;

const radiusClasses = {
  card: "rounded-2xl",
  demo: "rounded-xl",
  pill: "flex w-fit select-none items-center justify-center gap-1 rounded-full",
};

interface FrameProps extends React.ComponentProps<"div"> {
  radius: keyof typeof radiusClasses;
}

export function Frame({ radius, className, style, ...props }: FrameProps) {
  return (
    <div
      className={cn(
        "bg-gray-background shadow-custom",
        radiusClasses[radius],
        className
      )}
      style={{ padding: FRAME_PADDING, ...style }}
      {...props}
    />
  );
}
